import { useState , Suspense ,useRef,useEffect} from 'react';
import AppLoading from '../app-loading/app-loading';
import { Toast } from 'primereact/toast';
import PaymentLinkListDataTable from './resend-payment-link-Datatable';
import orderServices from '../../services/orders/orderservice';

interface DataTableProps {
  dateFilter: any;
}

const PaymentLinkResendList: React.FC<DataTableProps> = (dateFilter) => {
    const [loading, setLoading] = useState(false);
    const[paymentLinkList,setPaymentLinkList] = useState<any>(null)
    const toast = useRef<Toast>(null);

    useEffect(() => {
        setLoading(true);
           orderServices.getPaymentLinkList(dateFilter).then((response:any) => {
           if(response.length > 0){
               setPaymentLinkList(response);
               setLoading(false)
            }
            else{
               setPaymentLinkList(response);
               setLoading(false)
            }
        });
    },[dateFilter]);

    return (
        <Suspense fallback={<AppLoading />}>
          <Toast ref={toast} />
          <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
            <div className="col-12">
              {
                paymentLinkList != null ? <PaymentLinkListDataTable dataList={paymentLinkList}/> : 
                " "
              }
            </div>
          </div>
         {loading && <AppLoading />}
        </Suspense>
    )

}

export default PaymentLinkResendList;